











































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetPatCourseTemps, SavePatCourse, SavePatCourseTemp} from "@/api/hd"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() data: any
	@Prop() value: boolean
	// 左侧病历模板列表
	leftData: any = []
	// 记录左侧leftData选中的Index
	leftDataLastSelectedIndex = 10000
	// 控制模板modal显示和标题
	tempModal: any = {
		show: false,
		title: ''
	}
	temp: any = {
		name: '',
		ownerLevel: 0,
		contentHtml: '',
		content: ''
	}
	//新增编辑病程记录
	model: any = {
		inputDate: new Date()
	}
	// 查询模板列表
	query: any = {
		ownerLevel: 0,
	}

	created() {
		if (this.data.mode !== 'add') {
			this.model = this.data.item
		}
		this.getTemps()
	}

	leftChange(index: number) {
		this.leftDataLastSelectedIndex = index
		let temp = this.leftData[index]
		this.model.content = temp.content
		this.model.contentHtml = temp.contentHtml
		this.model.inputDate = this.model.inputDate || new Date()
	}

	async save() {
		if (!this.model.contentHtml) {
			this.$Message.error("请输入病程记录内容！")
			return
		}
		this.model.content = this.model.contentHtml.replace(/<.*?>/g, '')
		this.model.patientId = this.data.patient.id
		this.model.inputDate = this.formatDate(this.model.inputDate)
		let res = await SavePatCourse(this.model)
		if (res.status === 1) {
			this.$emit('save-success')
		}
	}

	async tempSave() {
		if (!this.temp.name) {
			this.$Message.error("请输入模板名称！")
		} else if (!this.temp.contentHtml) {
			this.$Message.error("请输入模板内容！")
		} else {
			this.temp.content = this.temp.contentHtml.replace(/<.*?>/g, '')
			let res = await SavePatCourseTemp(this.temp)
			if (res.status === 1) {
				this.tempModal.show = false
				this.getTemps()
			}
		}
	}

	addTemp() {
		this.temp = {
			name: '',
			ownerLevel: 0,
			contentHtml: '',
			content: ''
		}
		this.tempModal = {
			show: true,
			title: '新增模板'
		}
	}

	editTemp() {
		if (this.leftDataLastSelectedIndex === 10000) {
			this.$Message.error('您没有选择左侧模板！')
			return
		} else {
			this.temp = this.leftData[this.leftDataLastSelectedIndex]
		}
		this.tempModal = {
			show: true,
			title: '编辑模板'
		}
	}

	tempCancel() {
		this.tempModal.show = false
	}

	cancel() {
		this.$emit('input', false)
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	tempVisibleChange(value: boolean) {
		if (!value) {
			this.tempModal.show = false
		}
	}

	get dialogTitle() {
		return this.data.mode == 'add' ? '新增' : '编辑' + "  病程记录"
	}

	private async getTemps() {
		let res = await GetPatCourseTemps(this.query)
		this.leftData = res.objects
		this.leftData[0].selected = true
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/courseRecord/addOrEdit.vue